import axios from 'axios';
import { serverConfig } from './server-config';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      location.reload();
    }
    return Promise.reject(error);
  }
);
const getHeaders = () => ({
  Authorization: 'Bearer ' + localStorage.getItem('authToken'),
  'Content-Type': 'application/json',
});

export const ClientService = {

  updateContactPerson: (payload) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client/update/contact-person`,
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },


  findMatching: (prefix) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/client/find-matching`,
      {
        params: { prefix },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  deactivateClient: (clientId) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/admin-actions/deactivate/client/${clientId}`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  reactivateClient: (clientId) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/admin-actions/activate/client/${clientId}`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  addClient: (client) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/client/add`, client, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  updateClient: (client) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/client/update`, client, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  addClientSubscription: (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client/add-subscription`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  getAllClients: (pageIndex, pageSize, clientName = '') => {
    const query = `?page=${pageIndex || 0}&size=${pageSize || 10}&companyName=${clientName}`;
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/client/get/all${query}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  getClientById: (clientId) => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/client/get/${clientId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  createClientFolder: (clientId, folderName) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-folder/create`,
      {},
      {
        params: {
          clientId: clientId,
          folderName: folderName
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        }
      }
    );
  },

  curateCandidateToFolder: (clientId, candidateId, folderId) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/curate`,
      {},
      {
        params: {
          clientId: clientId,
          candidateId: candidateId,
          folderId: folderId,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
      }
    );
  },



  getCuratedFolders: (
    clientId,
    type = "CURATED",
    page = 0,
    size = 10
  ) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/client-folder/folders/list/${clientId}`,
      {
        params: {
          type,
          page,
          size
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        }
      }
    );
  },

  getCuratedByClientAndCandidate: async (clientId, candidateId, page = 0, size = 10) => {
    try {
      const response = await axios.get(
        `https://${serverConfig.serverBaseAddress}/signite/client-folder/curated/search`,
        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          },
          params: {
            clientId,
            candidateId,
            page,
            size,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching curated candidates:', error);
      throw error;
    }
  },

  uncurateCandidate: (clientId, candidateId, folderId) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/uncurate`,
      {},
      {
        params: {
          clientId: clientId,
          candidateId: candidateId,
          folderId: folderId
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
      }
    );
  },

  updateCandidateStatus: (candidateId, clientId, status) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/change-status?clientId=${clientId}&candidateId=${candidateId}&status=${status}`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },



  createFolder: (clientId, folderName) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/folder/create?clientId=${clientId}&folderName=${folderName}`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  listFolders: (clientId) => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/client-folder/folders/list-shortlisted/${clientId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  shortlistCandidate: (payload) =>
    axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/shortlist`,
      payload,
      { headers: getHeaders() }
    ),

  changeStatus: (payload) =>
    axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/change-status`,
      payload,
      { headers: getHeaders() }
    ),

  addNote: (payload) =>
    axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/shortlist/notes/add`,
      payload,
      { headers: getHeaders() }
    ),

  editNote: (payload) =>
    axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/shortlist/notes/edit`,
      payload,
      { headers: getHeaders() }
    ),

  deleteNote: (payload) =>
    axios.delete(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/shortlist/notes/delete`,
      {
        headers: getHeaders(),
        data: payload,
      }
    ),

  removeShortlistCandidate: (candidateId, folderId) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/shortlist/remove?candidateId=${candidateId}&folderId=${folderId}`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  moveFolder: (clientId, candidateId, destFolderId) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/shortlist/move-folder?clientId=${clientId}&candidateId=${candidateId}&destFolderId=${destFolderId}`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  getShortlistedCandidates: async (folderId, page = 0, size = 10, name = '', clientId = null) => {
    const response = await axios.get(`https://${serverConfig.serverBaseAddress}/signite/client-actions/shortlists/list`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
      params: {
        folderId: folderId || undefined,
        page: page,
        size: size,
        name: name,
        clientId: clientId || undefined,
      }
    });
    return {
      shortlists: response.data.shortlists || [],
      hasNext: response.data.hasNext || false,
      page: response.data.page || 0,
      totalCount: response.data.totalCount || 0,
      totalPages: response.data.pageCount || Math.ceil(response.data.totalCount / size),
    };
  },
  activeSubscriptionCount: (clientId) => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/client-actions/get/active-subscription`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
      params: {
        clientId: clientId,
      },
    });
  },

  submitClientFeedback: async (payload) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/submit-feedback`,
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  addClientSubscription: (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client/add-subscription`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  requestSubscription: (subscriptionType) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/request-subscription`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        params: {
          subscriptionType,
        },
      }
    );
  },


  purchaseSubscription: (subscriptionId, gateway = 'RAZORPAY') => {
    const payload = {
      productId: subscriptionId,
      productType: 'ASSESSMENT',
      gateway,
    };
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-actions/purchase/subscription`,
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  deleteClientDocument: (clientId, path) => {
    return axios.delete(
      `https://${serverConfig.serverBaseAddress}/signite/client/delete/doc`,
      {
        params: { clientId, path },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      });
  },
};
